if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
      }

      connectedCallback() {
        super.connectedCallback();

        this.content = this.querySelector('.product-media-modal__content');
        this.mediaItems = Array.from(this.content?.querySelectorAll('[data-media-id]') || []);
        this.currentCounter = this.querySelector('.product-media-modal__current');
        this.totalCounter = this.querySelector('.product-media-modal__total');
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.controls = this.querySelector('.product-media-modal__controls');

        if (this.totalCounter) this.totalCounter.textContent = this.mediaItems.length;
        this.bindNavigationControls();
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.setActiveIndex(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.setActiveIndex(this.currentIndex + 1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      bindNavigationControls() {
        if (this.navigationControlsBound) return;
        this.navigationControlsBound = true;

        const handleNavigation = (event) => {
          const button = event.target.closest('.product-media-modal__nav');
          if (!button || !this.contains(button)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (event.type === 'pointerup') {
            this.setActiveIndex(this.currentIndex + (button.name === 'previous' ? -1 : 1));
          }
        };

        this.addEventListener('pointerup', handleNavigation, true);
        this.addEventListener('click', handleNavigation, true);
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeIndex = this.mediaItems.findIndex((element) => element.getAttribute('data-media-id') === mediaId);
        this.setActiveIndex(activeIndex >= 0 ? activeIndex : 0);
      }

      setActiveIndex(index) {
        if (!this.mediaItems.length) return;

        const nextIndex = (index + this.mediaItems.length) % this.mediaItems.length;
        this.currentIndex = nextIndex;

        this.mediaItems.forEach((element, elementIndex) => {
          element.classList.toggle('active', elementIndex === nextIndex);
        });

        if (this.currentCounter) this.currentCounter.textContent = nextIndex + 1;
        this.loadActiveMedia(this.mediaItems[nextIndex]);
      }

      loadActiveMedia(activeMedia) {
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
